import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useSiteContent } from '../context/SiteContentContext';

const HeroSection = () => {
  const { getContent } = useSiteContent();
  
  const heroImage = getContent('hero_image', 'https://images.unsplash.com/photo-1670073952001-1aafed4bfc02');
  
  const scrollToBeta = () => {
    const element = document.getElementById('beta');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-background">
        <img
          src={heroImage}
          alt="Erebus Battle Arena"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="hero-content">
        <h1 className="hero-title">
          Fight for Erebus
        </h1>
        <p className="body-large mb-8">
          Master the elements. Defeat your rivals. Claim victory in the ultimate PvP arena.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <button onClick={scrollToBeta} className="btn-primary flex items-center justify-center gap-2">
            Join Beta <ArrowRight size={20} />
          </button>
          <button onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })} className="btn-secondary">
            Learn More
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
